import { recentBlogs } from "../../data/resourcesData";
import { Link } from "react-router-dom";
import ResourceHero from "./ResourceHero";
import "../../css/RecentBlogs.css";

export default function RecentBlogs() {
  return (
    <>
      <ResourceHero
        title="Recent Blogs"
        subtitle="Stay updated with the latest educational insights, school news, learning tips, and inspiring stories from our community."
        image="/images/Education_Funds3.png"
      />
      <section className="resources-section" id="recent-blogs">
        <div className="resources-heading-row">
          <h2 className="resources-heading">Recent Blogs</h2>

        </div>

        <div className="resources-recent-list">
          {recentBlogs.map((blog, index) => (
            <a href={blog.href} key={index} className="blog-card">
              <img src={blog.image} alt={blog.title} className="blog-image" />

              <div className="blog-overlay">
                <span className="blog-category">{blog.category}</span>

                <h3>{blog.title}</h3>

                <div className="blog-meta">
                  <span>{blog.author}</span>
                  <span>{blog.date}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
      {}

      <section className="blog-categories">
        <div className="container">
          <div className="section-heading">
            <span>Explore Topics</span>

            <h2>Popular Categories</h2>

            <p>
              Browse educational articles across different topics and stay
              informed with the latest insights.
            </p>
          </div>

          <div className="category-grid">
            <Link to="/recent-blogs" className="category-card">
              <h3>Education</h3>
              <span>15 Articles</span>
            </Link>

            <Link to="/recent-blogs" className="category-card">
              <h3>School News</h3>
              <span>10 Articles</span>
            </Link>

            <Link to="/recent-blogs" className="category-card">
              <h3>Student Life</h3>
              <span>12 Articles</span>
            </Link>

            <Link to="/recent-blogs" className="category-card">
              <h3>Parent Guide</h3>
              <span>8 Articles</span>
            </Link>
          </div>
        </div>
      </section>
      {}

      <section className="newsletter-section">
        <div className="container newsletter-wrapper">
          <div className="newsletter-content">
            <span>Stay Updated</span>

            <h2>Never Miss Our Latest Articles</h2>

            <p>
              Subscribe to receive school updates, educational blogs and
              important announcements directly in your inbox.
            </p>
          </div>

          <form className="newsletter-form">
            <input type="email" placeholder="Enter your email address" />

            <button type="submit">Subscribe</button>
          </form>
        </div>
      </section>
    </>
  );
}
